<template>
  <sub-page title="账户信息">
    <div class="account-page">
      <!-- 基本信息卡：证件/姓名/电话 -->
      <div class="group-card">
        <div class="list-item" v-for="(item, idx) in baseItems" :key="idx">
          <span class="item-label">{{ item.title }}</span>
          <span class="item-value">{{ item.value }}</span>
        </div>
      </div>

      <!-- 我的认证：跳转我的认证页 -->
      <div class="group-card cert-card">
        <div class="list-item" @click="goCertification">
          <span class="item-label">我的认证</span>
          <span class="item-value cert-value">已实人</span>
          <svg viewBox="0 0 24 24" class="arrow-icon"><path d="M9 5 L16 12 L9 19" fill="none" stroke="#C8C9CC" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'AccountInfo',
  components: { SubPage },
  data() {
    return {
      baseItems: [
        { title: '证件类型', value: '居民身份证' },
        { title: '证件号码', value: '34*************19' },
        { title: '姓名', value: '**杰' },
        { title: '移动电话', value: '1*********69' }
      ]
    }
  },
  methods: {
    // 我的认证 → 我的认证页
    goCertification() {
      this.$router.push('/my-certification')
    }
  }
}
</script>

<style scoped>
.account-page {
  background: #F5F5F5;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.group-card {
  background: #fff;
  overflow: hidden;
}
.cert-card {
  margin-top: calc(24 * var(--w));
}
.list-item {
  display: flex;
  align-items: center;
  height: calc(112 * var(--w));
  padding: 0 calc(40 * var(--w));
  border-bottom: 1px solid #F0F0F0;
  cursor: pointer;
}
.list-item:last-child {
  border-bottom: none;
}
.item-label {
  font-size: calc(42 * var(--w));
  color: #323233;
  flex-shrink: 0;
}
.item-value {
  flex: 1;
  font-size: calc(42 * var(--w));
  color: #999;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cert-value {
  color: #D88230;
}
.arrow-icon {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
  margin-left: calc(16 * var(--w));
}
</style>



// WEBPACK FOOTER //
// src/pages/AccountInfo.vue